var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{attrs:{"gutter":12,"id":"contact"}},[_c('el-card',{attrs:{"shadow":"hover"}},[_c('el-col',{attrs:{"span":24}},[_vm._v("\n      阿金的邮箱："),_c('a',{attrs:{"href":"mailto:disciple_sneaker@163.com"}},[_vm._v("disciple_sneaker@163.com")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-784323f5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = null
// module chunks = 